import { useCallback, useEffect, useState } from "react";
import { PopService } from "../services/PopService";
import { GenieAcsService } from "../services/GenieAcsService";

export const useHookGenieAcsById = ({ deviceId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await GenieAcsService.getDeviceById({deviceId : deviceId})
            setData(res.data.data);
        }catch(err){
            setError(err);
            // throw err;
        }finally{
            setLoading(false);
        }
    }, [deviceId]);

    useEffect(()=>{
        getData();
    },[getData]);

    return {
        data,
        loading,
        error,
        
        refreshData: () => getData(),
    }
}